
// import mainVideo from "../../assets/landing-page/vidoes/Clinical visual_V5.webm"
import { Box, Grid, Typography, Button } from '@mui/material';
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

const mainVideo = "Clinical visual_V5.webm";
const LandingVideo = () => {
  return (
    <Box
      className="slider_video"
      sx={{
        position: "relative",
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <Box
        component="video"
        src={VISUALIZE__URL + mainVideo}
        autoPlay
        loop
        muted
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      ></Box>
      <Box className="slider_content">
        <Grid container>
          <Typography
            variant="h4"
            sx={{ fontFamily: "Poppins", padding: "15px 0" }}
          >
            Welcome to Clinical Visuals
          </Typography>
          <Typography variant="h5" sx={{ fontFamily: "Dosis" }} gutterBottom>
            "Medical animation(clinical Visuals) brings the inner workings of
            the human body to life, turning complex processes into clear, visual
            stories that anyone can understand."
          </Typography>
          <Button
            component="a"
            href="/animation-portfolio"
            variant="contained"
            className="slider_content_link"
          >
            Animation Portfolio
          </Button>
        </Grid>
      </Box>
    </Box>
  );
};


export default LandingVideo;
